import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paperWidthMd': {
      maxWidth: '844px !important'
    }
  },
  title: {
    marginBottom: 12
  },
  content: {
    display: 'grid',
    gap: 20,
    gridTemplateColumns: '1fr 1fr',
    height: 500
  },
  datePickerContainer: {
    // marginRight: 57,
    width: '100%',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: 350
  },
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '70%',
    maxWidth: 847,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  }
}))

export default useStyles
